import { SVGProps } from "react";
import Truck from "./truck";
import Locate from "./locate";
import Store from "./store";
import Phone from "./phone";
import Package from "./PackageIcon";
import { IconMap } from "./types";
import Clock from "./clock";
import CheckMark from "./CheckMark";
import PlaceholderThumbnail from "./PlaceholderThumbnail";
import ArrowRight from "./ArrowRight";
import Exchange from "./Exchange";
import PlaceholderPictures from "./PlaceholderPictures";
import OriginalPayment from "./OriginalPayment";
import GiftCard from "./GiftCard";
import StoreCredit from "./StoreCredit";
import ShippingLabel from "./ShippingLabel";
import Printerless from "./Printerless";
import NarvarBadge from "./NarvarBadge";
import Favorite from "./Favorite";
import CheckCircle from "./CheckCircle";
import Error from "./Error";
import Reshop from "./Reshop";
import ShippingProtection from "./ShippingProtection";
import HelpCircle from "./HelpCircle";

export const icons = {
  Truck,
  Locate,
  Store,
  Package,
  Clock,
  Phone,
  CheckMark,
  PlaceholderThumbnail,
  ArrowRight,
  Exchange,
  PlaceholderPictures,
  OriginalPayment,
  GiftCard,
  Reshop,
  StoreCredit,
  ShippingLabel,
  Printerless,
  NarvarBadge,
  Favorite,
  CheckCircle,
  Error,
  ShippingProtection,
  HelpCircle,
};

const Icon = ({
  icon,
  ...props
}: { icon: IconMap } & SVGProps<SVGSVGElement>) => icons[icon](props);

export default Icon;

export type { IconMap };
